import { render, staticRenderFns } from "./damagedRecord.vue?vue&type=template&id=4f5e5f18"
import script from "./damagedRecord.vue?vue&type=script&lang=js"
export * from "./damagedRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports